$a.each_current_and_future('.load_async', function (el) {
  var url;
  url = el.data('url');
  if (url) {
    return $.ajax({
      url: url
    }).done(function (data) {
      return el.html(data).show();
    });
  }
});